const SCHEDULER_SHEET_ALL_TABS = [
  "tasks",
  "events",
  "todos",
  "accounting",
  "stats",
  "time",
  "clients_birthdays",
  "free_slots",
] as const;
export type tSchedulerSheetTab = (typeof SCHEDULER_SHEET_ALL_TABS)[number];
export const SCHEDULER_SHEET_MASTER_TABS = [...SCHEDULER_SHEET_ALL_TABS];
export const SCHEDULER_SHEET_SALOON_TABS = SCHEDULER_SHEET_MASTER_TABS.filter(
  (t) => t !== "events" && t !== "todos",
);
export const SCHEDULER_SHEET_STD_TABS: tSchedulerSheetTab[] = [
  "todos",
  "events",
  "accounting",
  "stats",
];
export const SCHEDULER_DEFAULT_SHEET_TAB: tSchedulerSheetTab = "tasks";

export type tSchedulerCalendarView =
  | "dayGridMonth"
  | "timeGridWeek"
  | "timeGridDay"
  | "listWeek";
export const SCHEDULER_DEFAULT_CALENDAR_VIEW: tSchedulerCalendarView =
  "timeGridDay";
